/**
 * @param {Function} hitAxios
 * @param {{ page?: number, limit?: number, status?: string, categoryId?: string }} [opts]
 */
export async function listVideoJobs(hitAxios, opts = {}) {
  const params = new URLSearchParams();
  // `list_page` — not `page` — so we never clash with the dashboard route `?page=video-library`.
  if (opts.page) params.set("list_page", String(opts.page));
  if (opts.limit) params.set("limit", String(opts.limit));
  if (opts.status) params.set("status", opts.status);
  if (opts.categoryId) params.set("category_id", opts.categoryId);

  const qs = params.toString();
  const path = qs ? `/api/video-studio/jobs?${qs}` : "/api/video-studio/jobs";

  const res = await hitAxios({
    path,
    post: false,
    showLoading: false,
    showSnackbar: false,
  });

  if (res?.logout) {
    throw new Error("Session expired. Please sign in again.");
  }
  if (!res?.data?.success) {
    throw new Error(res?.data?.msg || "Could not load videos.");
  }

  return {
    jobs: res.data.data?.jobs || [],
    pagination: res.data.data?.pagination || null,
  };
}
